/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import Logo from "components/icons/Logo";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "components/common/Button";
import Colors from "assets/Colors.js";
import LanguageSelector from "containers/SideBarTopMenuHOC/LanguageSelector";
import { Carousel, Col, Row, Input } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import useScreenSize from "hooks/useScreenSize";
import { useRealmApp } from "RealmApp";
import { useTranslation } from "react-i18next";
import Footer from "components/common/Footer";
import onboarding3 from "../../assets/images/onboarding3.png";
import onboarding2 from "../../assets/images/onboarding2.png";
import onboarding1 from "../../assets/images/onboarding1.png";
import wallpaper from "../../assets/images/LoginBackground.png";
import s from "./styles";

function RestorePassword() {
  const { t } = useTranslation();
  const app = useRealmApp();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { search } = useLocation();

  const [send, setSend] = useState(false);

  const params = useMemo(() => new URLSearchParams(search), [search]);
  useEffect(() => {
    if (!params.get("token") || !params.get("tokenId")) {
      navigate("/500");
    }
  }, []);

  const { handleSubmit, getFieldProps, isValid, errors } = useFormik({
    initialValues: {
      password: "",
      repeatPassword: "",
      token: params.get("token") || "",
      tokenId: params.get("tokenId") || "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required(t("containers.RestorePassword.required"))
        .min(8, t("containers.RestorePassword.passwordMustBeAtLeastMessage"))
        .matches(
          // eslint-disable-next-line no-useless-escape
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/,

          t("containers.RestorePassword.passwordMustBeAtLeast")
        ),
      repeatPassword: Yup.string()
        .required(t("containers.RestorePassword.required"))
        .oneOf(
          [Yup.ref("password"), null],
          t("containers.RestorePassword.passwordMustMatch")
        ),
    }),
    onSubmit: (values) => {
      setLoading(true);
      app.emailPasswordAuth
        .resetPassword({
          password: values.password,
          token: values.token,
          tokenId: values.tokenId,
        })
        .then(() => {
          setSend(true);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          navigate("/500");
        })
        .finally(() => setLoading(false));
    },
  });

  const { height } = useScreenSize();

  return (
    <>
      <s.headerContainer>
        <a href="/">
          <Logo />
        </a>
        <LanguageSelector login />
      </s.headerContainer>

      <Row>
        <Col xs={24} md={12}>
          <s.formContainer>
            <s.form>
              {send ? (
                <s.Title style={{ marginTop: "-50px" }}>
                  {t("containers.RestorePassword.restorePassword")}
                </s.Title>
              ) : (
                <s.Title>
                  {t("containers.RestorePassword.recoverPassword")}
                </s.Title>
              )}
              <s.line />

              {/* ******* */}
              {send ? (
                <>
                  <s.SubTitle style={{ marginTop: "36px" }}>
                    {t("containers.RestorePassword.restorePasswordMessage")}
                  </s.SubTitle>
                  <Button
                    onClick={() => {
                      navigate("/login");
                    }}
                    style={{
                      background: Colors.primary_web,
                      color: Colors.text_on_secondary,
                      marginTop: "20px",
                    }}
                  >
                    {" "}
                    {t("containers.RestorePassword.login")}
                  </Button>
                </>
              ) : (
                <>
                  <s.SubTitle style={{ marginTop: "36px" }}>
                    {t("containers.RestorePassword.newPassword")}
                  </s.SubTitle>
                  <Input.Password
                    placeholder={t("containers.RestorePassword.password")}
                    type="password"
                    style={{
                      marginBottom: "20px",
                      height: "40px",
                    }}
                    {...getFieldProps("password")}
                  />
                  <s.errorMessage>{errors.password}</s.errorMessage>
                  <s.SubTitle>
                    {t("containers.RestorePassword.repetNewPassword")}
                  </s.SubTitle>
                  <Input.Password
                    placeholder={t("containers.RestorePassword.password")}
                    type="password"
                    style={{
                      marginBottom: "36px",
                      height: "40px",
                    }}
                    {...getFieldProps("repeatPassword")}
                  />
                  <s.errorMessage
                    style={{ marginTop: "-34px", marginBottom: "36px" }}
                  >
                    {errors.repeatPassword}
                  </s.errorMessage>
                  {isValid ? (
                    <Button
                      loading={loading}
                      type="primary"
                      onClick={handleSubmit}
                      style={{
                        background: Colors.primary_web,
                        opacity: isValid ? 1 : 0.5,
                        color: Colors.text_on_secondary,
                      }}
                    >
                      {t("containers.RestorePassword.restore")}
                    </Button>
                  ) : (
                    <Button
                      loading={loading}
                      type="primary"
                      onClick={handleSubmit}
                      disabled
                      style={{
                        background: Colors.primary_web,
                        opacity: isValid ? 1 : 0.5,
                        color: Colors.text_on_secondary,
                      }}
                    >
                      {t("containers.RestorePassword.restore")}
                    </Button>
                  )}
                </>
              )}
            </s.form>
            {!send && (
              <s.NoAccountText style={{ paddingBottom: "16px" }} href="/login">
                {t("containers.RestorePassword.rememberPassword")}
                <p
                  style={{
                    marginLeft: "3px",
                    fontWeight: "400",
                    fontSize: "16px",
                  }}
                >
                  <s.register href="/login">
                    {t("containers.RestorePassword.login")}
                  </s.register>
                </p>
              </s.NoAccountText>
            )}
          </s.formContainer>
        </Col>
        <Col
          xs={0}
          md={12}
          style={{
            backgroundImage: `url(${wallpaper})`,
            minHeight: "100vh",
            height: "auto",
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          <Carousel
            autoplay
            style={{
              height: height < 687 ? "687px" : "100vh",
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={{}}>
              <s.imageContainer>
                <img
                  src={onboarding1}
                  style={{ maxWidth: "500px", width: "100%" }}
                />
              </s.imageContainer>
              <s.textContainer>
                <div
                  style={{ width: "50%", textAlign: "center", color: "white" }}
                >
                  <s.TitleLeft>
                    {t("containers.RestorePassword.onboardingTitle")}
                  </s.TitleLeft>
                  <s.SubTitleRight>
                    {t("containers.RestorePassword.onboardingMessage")}
                  </s.SubTitleRight>
                </div>
              </s.textContainer>
            </div>
            <div style={{}}>
              <s.imageContainer>
                <img
                  src={onboarding2}
                  style={{ maxWidth: "500px", width: "100%" }}
                />
              </s.imageContainer>
              <s.textContainer>
                <div
                  style={{ width: "50%", textAlign: "center", color: "white" }}
                >
                  <s.TitleLeft>
                    {t("containers.RestorePassword.onboardingTitle2")}
                  </s.TitleLeft>
                  <s.SubTitleRight>
                    {t("containers.RestorePassword.onboardingMessage2")}
                  </s.SubTitleRight>
                </div>
              </s.textContainer>
            </div>
            <div style={{}}>
              <s.imageContainer>
                <img
                  src={onboarding3}
                  style={{ maxWidth: "500px", width: "100%" }}
                />
              </s.imageContainer>
              <s.textContainer>
                <div
                  style={{ width: "50%", textAlign: "center", color: "white" }}
                >
                  <s.TitleLeft>
                    {t("containers.RestorePassword.onboardingTitle3")}
                  </s.TitleLeft>
                  <s.SubTitleRight>
                    {t("containers.RestorePassword.onboardingMessage3")}
                  </s.SubTitleRight>
                </div>
              </s.textContainer>
            </div>
          </Carousel>
        </Col>
      </Row>
      <Footer marginTop="-35px" />
    </>
  );
}

export default RestorePassword;
